import { MaxParamThresholds } from './getMaxAmountOpen'

/**
 * Compute the maximum dollar amount for a collateral swap without
 * dropping the health factor below `SAFE_HF`.
 *
 * A collateral swap withdraws $X of asset A and deposits $X of asset B.
 * The borrow-discounted collateral changes by `(ltvOut - ltvIn) * X`.
 *
 * If the target asset has a higher LTV than the source, the swap always
 * improves health → returns Infinity (capped by position size upstream).
 *
 * @param borrowDiscountedCollateral  Current risk-adjusted collateral
 * @param adjustedDebt               Current risk-adjusted debt
 * @param ltvIn   borrowCollateralFactor of the withdrawn (source) asset
 * @param ltvOut  borrowCollateralFactor of the deposited (target) asset
 * @returns Maximum dollar amount that can be swapped
 */
export function getMaxAmountCollateralSwap(
  borrowDiscountedCollateral: number,
  adjustedDebt: number,
  ltvIn: number,
  ltvOut: number,
): number {
  // Swapping to a higher-LTV asset always improves health
  if (ltvOut >= ltvIn) return Infinity

  const denominator = ltvIn - ltvOut
  return (
    (borrowDiscountedCollateral - MaxParamThresholds.SAFE_HF * adjustedDebt) /
    denominator
  )
}
